import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { KcPage } from "./keycloak-theme/kc.gen";

// The Keycloak login theme and the CRM app share this bundle. When Keycloak
// serves a page it injects window.kcContext; otherwise we are in the app.
const AppEntrypoint = lazy(() => import("./index.app"));

/*
// Uncomment to test a login page with `yarn start` (comment back afterwards!):
import { getKcContextMock } from "./keycloak-theme/login/KcPageStory";
if (process.env.NODE_ENV === "development") {
    window.kcContext = getKcContextMock({ pageId: "login.ftl", overrides: {} });
}
*/

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <StrictMode>
        {window.kcContext !== undefined ? (
            <KcPage kcContext={window.kcContext} />
        ) : (
            <Suspense>
                <AppEntrypoint />
            </Suspense>
        )}
    </StrictMode>,
);
